import {FormChooseExternal} from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemDeTitle} from '../DE/FormChooseDe.jsx'
import {FormItemDoName, FormItemDoNo} from '../DO/FormChooseDo.jsx'

export default function FormChooseDe(props) {
    return (
        <FormChooseExternal {...props}>
            <FormItemDoNo />
            <FormItemDoName />
            <FormItemDeTitle />
        </FormChooseExternal>
    )
}
